// 新增编辑预支付
<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">{{ title }}</div>
      </div>
      <el-form :model="form" label-width="110px">
        <!-- 付款信息start -->
        <div class="basic-infor">
          <div class="import-title">
            <span class="form-title">付款信息</span>
          </div>
          <div class="customer-information">
            <div class="cols">
              <div class="col-itms">
                <div class="title">付款方：</div>
                <div class="content-info w200">{{ form.payTenantName }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">收款方：</div>
                <div class="content-info w300">{{ form.receiveTenantName }}</div>
              </div>
            </div>

            <div class="cols">
              <div class="col-itms">
                <div class="title">收款账户类型：</div>
                <div class="content-info w200">{{ getName(form.accountType, '账户类型') }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">收款银行：</div>
                <div class="content-info w200">{{ form.bankName }}</div>
              </div>
            </div>

            <div class="cols">
              <div class="col-itms">
                <div class="title">收款账户：</div>
                <div class="content-info w200">{{ form.bankAccount }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">收款日期：</div>
                <div class="content-info w200">{{ form.receiveDate }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">收款金额(元)：</div>
                <div class="content-info w200">{{ form.receiveAmount }}</div>
              </div>

              <div class="col-itms second">
                <div class="title">对应款项：</div>
                <div class="content-info w200">{{ getName(form.correspondItem, '对应款项') }}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">大写金额：</div>
                <div class="content-info w200">{{ (form.receiveAmount || '') | smallToBig }}</div>
              </div>
              <div class="col-itms second">
                <div class="title">是否垫资款：</div>
                <div class="content-info w200">{{ getName(form.isCapitalAdvances, '是否') }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 付款信息end -->

        <!-- start of 预支付信息 -->
        <div class="back-color-fff form-box">
          <div class="import-title" style="position: relative">
            <span class="form-title">预支付信息</span>
            <el-button
              class="sub-operate-add3"
              type="defalut"
              size="small"
              v-show="payment.length === 0"
              @click="addPayItem"
              >新增</el-button
            >
          </div>
          <div class="form-item-box" v-for="(item, index) in payment" :key="index">
            <el-row style="padding: 10px 0px">
              <div class="sub-title">
                <span>预支付信息{{ index + 1 }}</span>
                <div style="display: flex">
                  <div style="position: relative">
                    <el-button
                      class="sub-operate-add2"
                      type="defalut"
                      size="small"
                      v-show="index === 0"
                      @click="addPayItem"
                      >新增</el-button
                    >
                    <el-button type="danger" size="mini" @click="delPayItem(item, index)">删除</el-button>
                  </div>
                </div>
              </div>
            </el-row>
            <el-row>
              <!-- 支付日期-->
              <el-col :span="12">
                <el-form-item label="预支付日期" required>
                  <el-date-picker
                    size="small"
                    class="w300"
                    type="date"
                    placeholder="请选择"
                    v-model="item.prePaymentDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    @change="blurCheck"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <!-- 下游支付方 -->
              <el-col :span="12">
                <el-form-item label="下游支付方" required>
                  <el-select
                    filterable
                    size="small"
                    class="w300"
                    @change="serviceChange(item, item.levyTenantGuid)"
                    clearable
                    v-model="item.levyTenantGuid"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in serviceTenantList"
                      :key="index"
                      :label="item.tenantName"
                      :value="item.guid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 支付金额 -->
              <el-col :span="12">
                <el-form-item label="支付金额" required>
                  <el-input
                    size="small"
                    class="w300"
                    type="text"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    @blur="item.payAmount = $event.target.value"
                    maxlength="12"
                    v-model="item.payAmount"
                    placeholder="请填写支付金额"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 大写金额 -->
              <el-col :span="12">
                <el-form-item label="大写金额">
                  {{ (item.payAmount || '') | smallToBig }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-item-box sum-box"  v-if="payment.length && payment.length > 0">
            <el-row>
              <el-col :span="12">
                <div class="sum-row">合计</div>
                <span >
                {{ getSumAmount(payment)| numDigit }} 元
              </span>
                
              </el-col>

            
            </el-row>
          </div>
        </div>
        <!-- end of 预支付信息 -->

        <!-- 审批按钮 -->
        <div class="operte-btns">
          <div class="btn cancel" @click="$router.go(-1)">取消</div>
          <div class="btn submit" @click="sumbit('Y')">确定</div>
        </div>
        <!-- 审批按钮 -->
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      rowData: {}, // #列表带过来的数据做兜底
      pickerOptions: {},
      payment: [], // 预支付列表
      serviceTenantList: [], // 代征公司列表
      fullscreenLoading: false,
      guid: '',
      approveStaffName: '',
      form: {},
      title: '',
      checkedTitle: '', // 弹框标题
      btnTitle: '', // 弹框标题
      checkedIssuesText: '',
      placeholder: '', // 输入提示
      dialogVisible: false,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.title = this.$route.query.title;
    this.rowData = this.$route.query.rowData ? JSON.parse(this.$route.query.rowData) : {};
    this.getDetail(this.$route.query.guid);
    this.getPaymentDetail(this.$route.query.guid);
    this.getServiceTenantList();
  },
  methods: {
    getSumAmount(list, type) {
      let sum = 0;
      console.log('88',list);
      list.forEach((item) => {
        sum += Math.round(item.payAmount * 100) / 100 ;
      });
      return sum;
    },
    getFormData(detail) {
      this.form = detail;
      this.pickerOptions = {
        disabledDate(time) {
          return time.getTime() < new Date(detail.receiveDate).getTime();
        },
      };
    },
    getDetail(guid) {
      try {
        this.api.get(`/${serverConfig.msCustomerService}/invoiceItem/detail/${guid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let { data } = res.data;
            let detail = JSON.parse(JSON.stringify(data));
            this.getFormData(detail);
          } else {
            this.$message.error(res.data.msg);
            this.getFormData(this.rowData);
          }
        });
      } catch (error) {
        this.getFormData(this.rowData);
      }
    },
    getPaymentDetail(guid) {
      this.api
        .get(`/${serverConfig.msCustomerService}/pre-payment-info/list/by-paymentGuid?paymentGuid=${guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let { data } = res.data;
            let list = JSON.parse(JSON.stringify(data));
            if (list && list.length) {
              this.$set(this, 'payment', list);
            } else {
              let payment = [];
              this.$set(this, 'payment', payment);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },

    sumbit() {
      if (!this.checkPayList()) {
        return;
      }
      if (!this.form.payTenantGuid) {
        this.$message.error('付款方不能为空, 请稍后重试');
        return;
      }

      this.payment.forEach((item) => {
        item.paymentGuid = this.form.guid;
        item.payTenantGuid = this.form.payTenantGuid;
        item.payTenantName = this.form.payTenantName;
        item.tenantGuid = localStorage.guid; // 当前登录人公司
      });
      let param = {
        paymentGuid: this.form.guid,
        prePaymentInfoDTO: this.payment,
      };
      this.api.put(`/${serverConfig.msCustomerService}/pre-payment-info/update`, param).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('操作成功');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    blurCheck() {
      try {
        let repetitionArr = this.findRepeatPayment(JSON.parse(JSON.stringify(this.payment)));
        if (repetitionArr.length) {
          throw new Error(`同一日期同一支付方不可重复添加`);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    checkPayList() {
      try {
        // 判空校验
        this.payment.forEach((item, index) => {
          if (!item.prePaymentDate) {
            throw new Error(`预支付信息${index + 1}-预支付日期不能为空`);
          } else if (item.prePaymentDate) {
            if (new Date(item.prePaymentDate).getTime() < new Date(this.form.receiveDate).getTime()) {
              throw new Error(`预支付信息${index + 1}-预支付日期不可早于收款日期`);
            }
          }
          if (!item.levyTenantGuid) {
            throw new Error(`预支付信息${index + 1}-下游支付方不能为空`);
          }
          if (!item.payAmount) {
            throw new Error(`预支付信息${index + 1}-支付金额不能为空`);
          } else if (item.payAmount > this.form.receiveAmount) {
            throw new Error(`支付金额不能大于收款金额`);
          }
        });

        let total = this.payment.reduce((prev, cur) => prev + Number(cur.payAmount), 0);
        if (total > this.form.receiveAmount) {
          throw new Error(`多笔预支付金额合计需小于等于收款金额`);
        }

        let repetitionArr = this.findRepeatPayment(JSON.parse(JSON.stringify(this.payment)));
        if (repetitionArr.length) {
          throw new Error(`同一日期同一支付方不可重复添加`);
        }

        return true;
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }
    },
    getJSONContent(josnStr) {
      let str = '';
      if (josnStr) {
        let jsonObj = JSON.parse(josnStr);
        str = jsonObj.map((item) => item.name).join('、');
      }
      return str;
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    addPayItem() {
      this.payment.push({
        prePaymentDate: '',
        payTenantGuid: '',
        payAmount: '',
      });
    },
    //删除预支付
    delPayItem(item, index) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.payment.splice(index, 1);
      });
    },
    //获取乙方
    getServiceTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9904'],
      };
      this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.serviceTenantList = res.data.data.records;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    serviceChange(currentPay, val) {
      let itemObj = this.serviceTenantList.find((item) => item.guid === val);
      if (itemObj) {
        currentPay.levyTenantName = itemObj.tenantName;
      }
      try {
        let repetitionArr = this.findRepeatPayment(JSON.parse(JSON.stringify(this.payment)));
        if (repetitionArr.length) {
          throw new Error(`同一日期同一支付方不可重复添加`);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // todo 同一日期同一支付方校验
    findRepeatPayment(list) {
      list.forEach((item) => {
        item.key = `${item.prePaymentDate}${item.levyTenantGuid}`;
      });
      let deWeightArr = []; // 去重后的数组
      let repetitionArr = []; // 重复的数组
      list.forEach((item1) => {
        const check = deWeightArr.every((item2) => {
          return item1.key !== item2.key;
        });
        check ? deWeightArr.push(item1) : repetitionArr.push(item1);
      });
      console.log('重复的数据================>>>>>', repetitionArr);
      return repetitionArr;
    },
  },
};
</script>

<style lang="less" scoped>
.sum-box .el-col-12{
  display: flex;
  color: #606266;
}
.sum-row{
  width: 98px;
  text-align: right;
  padding-right: 12px;
}
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}
.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: -35px;
  text-align: center;
}

.sub-operate-add3 {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 12px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  /* margin-right: 16px; */
}

.customer-information .col-itms.second {
  margin-left: 170px;
}

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.operte-btns .btn.reject {
  border: 1px solid #f56c6c;
  background-color: #ffffff;
  color: red;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.bank-info {
  color: #a7a7a7;
}
/* 新增样式 */
.w200 {
  width: 200px;
}
.w300 {
  width: 200px;
}
.title {
  color: #666666;
}
.title-col {
  color: #666666;
  text-align: left;
  height: 32px;
  line-height: 32px;
}
.content-info {
  text-align: left;
  color: #212121;
}
.other-info {
  width: 320px;
  padding-left: 70px;
}
.other-info-second {
  margin-left: 170px;
}
.content-box {
  line-height: 32px;
  width: 400px;
  min-height: 32px;
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  padding-left: 10px;
}
.content-info-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex-position {
  align-items: start !important;
}
/deep/.el-dialog__footer {
  border-top: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.basic-infor {
  position: relative;
}
.approve-img {
  position: absolute;
  top: 5px;
  right: 60px;
  width: 78px;
  height: 78px;
}
.no-data {
  padding-top: 100px;
  height: 100%;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.form-box {
  margin-top: 4px;
  text-align: left;
  overflow-y: auto;
  .form-box-title {
    display: flex;
    justify-content: space-between;
  }
  .form-title {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .form-item-box {
    width: 90%;
    margin: 0 auto;
    padding-bottom: 15px;
  }
  // .el-col-12 {
  //   height: 50px;
  // }
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-input,
  .el-select {
    width: 314px;
  }
  .age-are-box {
    display: flex;
    align-items: center;
    .el-input {
      width: 142px;
    }
    span {
      margin: 0px 8px;
    }
  }
  .bottom-btn-box {
    padding: 18px 0px;
    text-align: center;
    border-top: 1px solid #e5e5e5;
  }
}
</style>
